import {KTSVG} from '../../../../../../_metronic/helpers/components/KTSVG'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {initialQueryState} from '../../../../../../_metronic/helpers'

const RolesListSearchComponent = () => {
  const {state, updateState} = useQueryRequest()

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateState({
      ...state,
      search: e.target.value,
      page: 1,
    })
  }

  return (
    <div className='card-title'>
      <div className='d-flex align-items-center position-relative my-1'>
        <KTSVG
          path='/media/icons/duotune/general/gen021.svg'
          className='svg-icon-1 position-absolute ms-6'
        />
        <input
          type='text'
          data-kt-user-table-filter='search'
          className='form-control form-control-solid w-250px ps-14'
          placeholder='Search roles'
          value={state.search || ''}
          onChange={handleSearch}
        />
      </div>
    </div>
  )
}

export {RolesListSearchComponent} 